// extracted by mini-css-extract-plugin
module.exports = {"card":"_1kukryLH3XPi-R91HOUA6E","blue":"sZrV29uyhCTgcGh-IbrbF","white":"a_q-Zk_2YMiSHrm1hhkHE","graph":"_3LYyMXSGLQV1_0uRSq3Stt"};